import { LRUCache } from 'lru-cache';

import { ICacheService } from './types';

export type LRUCacheOptions = {
  max?: number;
  ttl?: number;
  updateAgeOnGet?: boolean;
  maxSize?: number;
  sizeCalculation?: (value: unknown, key: string) => number;
};

export class LRUCacheService implements ICacheService {
  private cache: LRUCache<string, object>;

  constructor(options: LRUCacheOptions = {}) {
    this.cache = new LRUCache<string, object>({
      max: options.max || 1000,
      ttl: options.ttl || 1 * 60 * 1000, // 1 minute default
      updateAgeOnGet: options.updateAgeOnGet ?? true,
      maxSize: options.maxSize,
      sizeCalculation: options.sizeCalculation,
    });
  }

  get<T>(key: string): T | undefined {
    return this.cache.get(key) as T | undefined;
  }

  set<T>(key: string, value: T, ttl?: number): void {
    if (ttl) {
      this.cache.set(key, value as object, { ttl });
    } else {
      this.cache.set(key, value as object);
    }
  }

  delete(key: string): void {
    this.cache.delete(key);
  }

  clear(): void {
    this.cache.clear();
  }

  has(key: string): boolean {
    return this.cache.has(key);
  }
}
